import { CmsObjectWithDefault } from '@components/Cms/types';

export type OtpLoginFormCmsKey =
    | 'pleaseTryAgain'
    | 'pleaseEnterValidMobileNumber'
    | 'invalidOtpCode'
    | 'technicalDifficulty'
    | 'youAreSuccessfullyLoggedIn'
    | 'youAreNotAllowedToLogIn'
    | 'yourMobileNumberOrPasswordIsIncorrect'
    | 'unauthorizedAcess'
    | 'successfullyVerified'
    | 'otpVerificationLimitExceeded';

export const OtpLoginFormCmsWithDefault: CmsObjectWithDefault<OtpLoginFormCmsKey> = {
    pleaseTryAgain: {
        cmsId: 269092,
        defaultTranslation: 'Sorry, we have encountered a technical issue. Please try again.',
    },
    pleaseEnterValidMobileNumber: {
        cmsId: 85560,
        defaultTranslation: 'Please enter a valid mobile number.',
    },
    invalidOtpCode: {
        cmsId: 97933,
        defaultTranslation: 'The OTP code is incorrect. Please re-enter or request a new OTP.',
    },
    technicalDifficulty: {
        cmsId: 101793,
        defaultTranslation: 'We are currently experiencing technical difficulties.',
    },
    youAreSuccessfullyLoggedIn: {
        cmsId: 115055,
        defaultTranslation: 'You are successfully logged in.',
    },
    youAreNotAllowedToLogIn: {
        cmsId: 115056,
        defaultTranslation: 'You are not allowed to log in.',
    },
    yourMobileNumberOrPasswordIsIncorrect: {
        cmsId: 82027,
        defaultTranslation: 'Your mobile number or password is incorrect.',
    },
    unauthorizedAcess: {
        cmsId: 252851,
        defaultTranslation: 'You are not allowed to access the page',
    },
    successfullyVerified: {
        cmsId: 252852,
        defaultTranslation: 'You have successfully verified your account',
    },
    otpVerificationLimitExceeded: {
        cmsId: 343953,
        defaultTranslation:
            'Your OTP request limit has been exceeded and has been blocked for 24 hours. Please try again later or contact support for assistance.',
    },
};
